// navigation module vuex
export const NAVIGATION = 'navigation';

// state props
export const BREADCRUMB = 'breadCrumb';

// getters
export const GET_SERVICES = 'getServices';
export const GET_CURRENT_LANG = 'getCurrentLang';
export const GET_ANONYMOUS = 'getAnonymous';
export const GET_CURRENT_SERVICE = 'getCurrentService';
export const GET_SUB_SERVICES = 'getSubServices';
export const GET_SERVICE_BY_PATH = 'getServiceByPath';
// mutations
export const RESET_SERVICE = 'resetService';
export const SET_CURRENT_SERVICE = 'setCurrentService';
export const SET_ANONYMOUS = 'setAnonymous';
// actions
export const CALL_ROUTE_CHANGED = 'callRouteChanged';

// map path part and breadcrumb labels
export const mapPathAndBreadcrumbLabels = {
	administration: 'navigations.adminTitle',
	userMgmt: 'navigations.usersTitle',
	accMgmt: 'navigations.accountManagementTitle',
	serviceMgmt: 'navigations.servicesTitle',
	services: 'navigations.subServicesTitle',
	access: 'navigations.accessTitle',
	editAccess: 'navigations.accessTitle',
	lookUp: 'navigations.accessTitle',
	rgpd: 'footer.dataProtection',
	legals: 'footer.legalMentions'
};

// PASS ACCOUNT NAME
export const ACCOUNT_MANAGEMENT_NAME = 'ACCOUNT_MANAGEMENT_NAME';
export const SERVICE_MANAGEMENT_ACCESS_NAME = 'SERVICE_MANAGEMENT_ACCESS_NAME';
export const SERVICE_MANAGEMENT_SERVICE_NAME = 'SERVICE_MANAGEMENT_SERVICE_NAME';
export const USER_MANAGEMENT_NAME = 'USER_MANAGEMENT_NAME';

